var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"distribution-bar"},[_c('div',{staticClass:"bar-container"},[_c('div',{staticClass:"bar investment",style:({
        width: _vm.investmentBarWidth,
        backgroundColor: _vm.investmentBarColor,
      })}),_c('div',{staticClass:"bar estimated-returns",style:({
        width: _vm.estimatedReturnsBarWidth,
        backgroundColor: _vm.estimatedReturnsBarColor,
      })})]),_c('div',{staticClass:"values"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.formattedTotalValue))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.formattedTotalReturns))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }